import { useState } from "react";
import Modal from "../../../../components/modals/Modal";
import { doc, writeBatch } from "firebase/firestore";
import { firestore } from "../../../../firebase/config";
import Button from "../../../../components/Button";
import { useTournament } from "../../TournamentContext";

const CreateGroups = () => {
  const { teams, tournamentId } = useTournament();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [numberOfGroups, setNumberOfGroups] = useState(1);

  const buttonText = "Create Groups";

  const toggleModal = () => {
    setIsModalOpen(!isModalOpen);
  };

  const writeGroups = async () => {
    const groups = {};
    const teamUpdates = {};

    Object.entries(teams).forEach(([teamId, team], index) => {
      if (!team) {
        console.warn(`Team with ID ${teamId} is undefined`);
        return;
      }

      const groupId = index % numberOfGroups;

      if (!groups[groupId]) {
        groups[groupId] = [];
      }

      groups[groupId].push(teamId);

      teamUpdates[`${teamId}.groupId`] = String(groupId);
    });

    const tournamentRef = doc(firestore, "tournaments", tournamentId);
    const teamsRef = doc(firestore, "teams", tournamentId);

    const batch = writeBatch(firestore);

    batch.update(tournamentRef, {
      groups,
      isRegistrationOpen: false,
    });

    batch.update(teamsRef, teamUpdates);

    try {
      await batch.commit();

      window.location.reload();

      // updateTournament("groups", groups);
      // handleSetItems(groups);
      // toggleModal();
    } catch (error) {
      console.log(error);
      alert("Error creating groups:", error.message);
    }
  };

  return (
    <>
      <Button
        color="indigo"
        dataTestId="add-groups-button"
        onClick={toggleModal}
      >
        {buttonText}
      </Button>

      <Modal
        isOpen={isModalOpen}
        title={"Create Groups"}
        subtitle={"For Swiss rounds select 1 with an even number of teams"}
        onCancel={toggleModal}
        onConfirm={writeGroups}
      >
        <div>Number of Groups</div>
        <select
          onChange={(event) => setNumberOfGroups(Number(event.target.value))}
          defaultValue={numberOfGroups}
        >
          <option value={1}>1</option>
          <option value={2}>2</option>
          <option value={3}>3</option>
          <option value={4}>4</option>
        </select>
      </Modal>
    </>
  );
};

export default CreateGroups;
